// @flow

export default class Listener {

  event: string;

  func: Function;

  constructor(event: string, func: Function) {
    this.event = event;
    this.func = func;
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/flux/Listener.js